// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon[data-v-f02860d2]{position:absolute;top:10px;right:0;background:#e2e2e2;border-radius:100%;width:30px;height:30px;line-height:30px;vertical-align:middle;text-align:center;color:#00f;font-size:14px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
